<template>
    <div>
        <ckeditor
            :editor="editor"
            v-model="editorContent"
            :config="editorConfig"
            @input="updateContent"
        ></ckeditor>
    </div>
</template>

<script>
import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use(CKEditor);

export default {
    name: 'CkEditor',
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            editor: 'classic',
            editorContent: this.value,
            editorConfig: {
                versionCheck:false,
                extraPlugins: [
                    'colorbutton', // Metin ve arka plan rengi
                    'colordialog', // Renk seçici diyalog
                    'font', // Font ailesi ve boyutu
                    'justify', // Hizalamalar
                    'link', // Bağlantılar
                    'image', // Resim ekleme
                    'table', // Tablo oluşturma
                    'list', // Listeler
                    'undo', // Geri al/yinele
                    'format', // Paragraf formatları
                    'specialchar', // Özel karakterler
                    'pastefromword', // Word'den yapıştırma
                    'codesnippet', // Kod parçacıkları
                    'find', // Bul ve değiştir
                    'maximize', // Tam ekran
                    'sourcearea', // Kaynak kodu
                    'div', // Div oluşturma
                    'horizontalrule', // Yatay çizgi
                    'iframe', // Iframe ekleme
                    'indent', // Girinti
                    'showblocks', // Blokları göster
                    'stylescombo', // Stil kombinasyonları
                ].join(','),
                toolbar: [
                    { name: 'document', items: ['Source', '-', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
                    { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                    { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll'] },
                    { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
                    { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
                    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                    { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Iframe', 'CodeSnippet'] },
                    { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                    { name: 'colors', items: ['TextColor', 'BGColor'] }, // Metin ve arka plan rengi
                    { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
                ],
                colorButton_colors: 'e14d43,00a859,282828,ffffff,CF5D4E,454545,FFF,DDD,CCEAEE,66AB16',
                colorButton_enableMore: true,
                height: 400,
                allowedContent: true,
                language: 'tr',
            },
        };
    },
    watch: {
        value(newValue) {
            if (newValue !== this.editorContent) {
                this.editorContent = newValue;
            }
        },
    },
    methods: {
        updateContent() {
            this.$emit('input', this.editorContent);
        },
    },
};
</script>

<style scoped>
/* Editör stilini özelleştirme */
.ck-editor {
    width: 100%;
}
</style>
